import { req, get, post } from '@/plugins/axios'
import type { res } from './login'

export const getPromoFlag = (data:any) => post('/smc/app/promotion/getPromoFlag', data)

export const changePromoFlag = (data:any) => post('/smc/app/pop/popSu', data)

export const getSmcBlackApi = () => get('/customer/checkSMCBlack')
